export default __webpack_public_path__ + "static/media/jackets.fb9cc50a.png";